import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function FinalCTA({
  title = "Let's talk about what you're building.",
  body = "A 30-minute discovery call to understand your goals and tell you honestly whether we're the right fit.",
}) {
  return (
    <section
      data-testid="final-cta-section"
      className="relative overflow-hidden bg-[var(--tmg-obsidian)] text-[var(--tmg-ivory)] tmg-grain"
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-30 pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(circle at 80% 20%, rgba(212,175,55,0.18), transparent 50%), radial-gradient(circle at 20% 80%, rgba(212,175,55,0.10), transparent 50%)",
        }}
      />
      <div className="relative max-w-7xl mx-auto px-6 sm:px-10 lg:px-20 py-24 sm:py-32 grid lg:grid-cols-12 gap-12 items-end">
        <div className="lg:col-span-8">
          <p className="tmg-overline-gold mb-6">— The Next Step</p>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold leading-[1.05] tracking-tight">
            {title}
          </h2>
          <p className="mt-8 text-base sm:text-lg text-white/75 max-w-2xl leading-relaxed">
            {body}
          </p>
        </div>
        <div className="lg:col-span-4 flex lg:justify-end">
          <Link
            to="/book-call"
            data-testid="final-cta-book-call-btn"
            className="tmg-btn-primary"
          >
            Book a Discovery Call <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
